<template>
  <v-container v-bind="$attrs">
    <v-form ref="form">
      <v-row no-gutters dense class="d-flex flex-wrap">
        <v-col lg="3" md="6" xs="12">
          <v-text-field
            v-model="form.courierNo"
            :label="$t('label.courier_no')"
            clearable
            required
            :rules="rules.courierNo"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters dense class="d-flex flex-wrap">
        <v-col lg="3" md="6" xs="12">
          <v-btn
            color="secondary"
            small
            @click.stop="beforeClaim"
            class="float-end"
          >
            {{ $t("label.claim") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="claimDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("message.are_you_sure") }}
        </v-card-title>
        <v-card-text class="font-weight-bold mt-3">{{
          $t("message.claim_cargo_declaration")
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small @click="claimCargo">
            <v-icon>{{ mdiCheck }}</v-icon
            >{{ $t("label.confirm") }}
          </v-btn>
          <v-btn color="secondary" small @click="claimDialog = false">
            <v-icon>{{ mdiClose }}</v-icon
            >{{ $t("label.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </v-container>
</template>

<script>
import { mdiCheck, mdiClose } from "@mdi/js";
import { ClaimCargo } from "@/api/publicServices";
import i18n from "../lang/lang";

export default {
  props: {},
  components: {},
  data: () => {
    const defaultForm = Object.freeze({
      courierNo: "",
    });
    return {
      defaultForm,
      form: Object.assign({}, defaultForm),
      claimDialog: false,
      formHasErrors: false,
      rules: {
        courierNo: [
          (val) => (val || "").length > 0 || i18n.t("label.required"),
        ],
      },
      snackBarMsg: {
        show: false,
        text: "",
        color: "red",
      },

      //svg icons
      mdiCheck,
      mdiClose,
    };
  },
  computed: {},
  methods: {
    beforeClaim() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.claimDialog = true;
    },
    async claimCargo() {
      try {
        let data = { CourierNo: this.form.courierNo };
        console.log(data);
        const response = await ClaimCargo(data);
        this.claimDialog = false;
        if (response.data.isSuccess) {
          this.resetForm();
          this.snackBarMsg.text = i18n.t("message.claimed_success");
          this.snackBarMsg.color = "secondary";
          this.snackBarMsg.show = true;
          console.log(response.data);
        } else {
          this.snackBarMsg.text = response.data.Msg;
          this.snackBarMsg.show = true;
        }
      } catch (error) {
        this.snackBarMsg.text = "Service Error";
        this.snackBarMsg.show = true;
        console.log(error);
      }
    },
    resetForm() {
      this.form = Object.assign({}, this.defaultForm);
      this.$refs.form.reset();
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
